import { CustomFilterItemProps } from '../components/custom/CustomFilterItem';
import { query } from '@trlogic/client-js';
import DataType from '../constant/DataType';
import QueryBuilder = query.QueryBuilder;
import SelectQueryBuilder = query.SelectQueryBuilder;
import eq = query.eq;
import neq = query.neq;
import Filter = query.Filter;
import and = query.and;
import or = query.or;
import empty = query.empty;
import gt = query.gt;
import gte = query.gte;
import lt = query.lt;
import lte = query.lte;

class FilterParser {
  public static toQuery(filters: CustomFilterItemProps[], query: SelectQueryBuilder = QueryBuilder.select()): query.SelectQueryBuilder {
    if (filters.length == 0) {
      return query;
    }
    const firstElement = filters.shift();
    if (firstElement == undefined) {
      return query;
    }
    let filter: Filter = this.parseFilter(firstElement);
    const previousFilter = query.build().filter;
    if (previousFilter) {
      if (firstElement.logic == 'and') {
        filter = and(filter, previousFilter);
      } else if (firstElement.logic == 'or') {
        filter = or(filter, previousFilter);
      }
    }
    query.where(filter);
    if (filters.length > 0) {
      this.toQuery(filters, query);
    }
    return query;
  }

  private static parseFilter(filter: CustomFilterItemProps): Filter {
    if (filter.field == undefined) return empty();
    const value = this.castValue(filter);
    switch (filter.operator) {
      case '==':
        return eq(filter.field.key, value);
      case '!=':
        return neq(filter.field.key, value);
      case '>':
        return gt(filter.field.key, value);
      case '>=':
        return gte(filter.field.key, value);
      case '<':
        return lt(filter.field.key, value);
      case '<=':
        return lte(filter.field.key, value);
      case 'includes':
        return eq(filter.field.key, {
          $regex: value,
          $options: 'i',
        });
      default:
        throw new Error('Unsupported filter operator');
    }
  }

  private static castValue(item: CustomFilterItemProps) {
    if (item.field == undefined) return null;
    switch (item.field.properties.dataType) {
      case DataType.STRING:
        return String(item.value);
      case DataType.NUMBER:
        return Number(item.value);
      case DataType.BOOLEAN:
        if (typeof item.value == 'string') {
          return item.value.toString() == 'true';
        } else if (typeof item.value == 'boolean') {
          return item.value;
        }
        return false;
    }
  }
}

export default FilterParser;
